import { type ReactElement } from 'react';
import Alert from '@fastnorth/kraken/components/alert';
import { useTranslation } from 'react-i18next';

const PrivateResultsBanner = (): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event.race.results' });

  return (
    <Alert
      data-testid={'private-results-banner'}
      title={t('private_banner.title', 'Results not yet public')}
      description={t(
        'private_banner.description',
        'These results are private and cannot be viewed by the public.'
      )}
      color={'info'}
    />
  );
};

export default PrivateResultsBanner;
